import type { IconSvgObject } from './types';

const PocketIcon: IconSvgObject = [
  ["path", { d: "M3 11V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V11C21 15.9706 16.9706 20 12 20C7.02944 20 3 15.9706 3 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 10L12 13L15 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PocketIcon;
